import $ from 'jquery';

var accordian = function() {

  $('.accordian__btn').on('click', function(e) {
    var _this = $(this);
    e.preventDefault();

    if (_this.parent().hasClass('active')) {
      _this.parent().removeClass('active');
      _this.next('.accordian__body').slideUp(400);
    } else {
      _this.parent().addClass('active');
      _this.next('.accordian__body').slideDown(400);
    }
  })
}

module.exports = accordian;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/accordian.js